var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileDeletedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 18.5,
    height: 18.5,
    rx: 9.25,
    stroke: "#DB2835",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0469 5.75488C13.3396 5.46216 13.8145 5.46242 14.1074 5.75488C14.4003 6.04778 14.4003 6.52351 14.1074 6.81641L10.9922 9.93066L14.1084 13.0469C14.401 13.3398 14.4012 13.8156 14.1084 14.1084C13.8156 14.4012 13.3398 14.401 13.0469 14.1084L9.93066 10.9922L6.81543 14.1084C6.52251 14.4006 6.04756 14.401 5.75488 14.1084C5.46207 13.8156 5.46224 13.3398 5.75488 13.0469L8.87012 9.93164L5.75488 6.81641C5.46199 6.52351 5.46199 6.04778 5.75488 5.75488C6.04778 5.46199 6.52351 5.46199 6.81641 5.75488L9.93164 8.87012L13.0469 5.75488Z",
    fill: "#DB2835"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDeletedIcon);
export default __webpack_public_path__ + "static/media/profileDeletedIcon.83b38dbaacb8725dc3705a1dd3a63e22.svg";
export { ForwardRef as ReactComponent };